import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MaterialModule } from './modules/shared/material/material.module';
import { OnlineStatusModule } from 'ngx-online-status';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { MatSidenavModule } from '@angular/material/sidenav';
import { AuthInterceptor } from './interceptor/auth.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { AuthModule } from './auth/auth.module';
import { registerLocaleData } from '@angular/common';
import localeUk from '@angular/common/locales/uk';
import localeEn from '@angular/common/locales/en';
import localeRu from '@angular/common/locales/ru';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from './modules/shared/shared.module';
import { MarkdownModule } from 'ngx-markdown';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ReqInterceptor } from './interceptor/req.interceptor';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { provideI18n, readStoredLanguage } from './core/i18n';

@NgModule({
  declarations: [AppComponent],
  exports: [SharedModule, TranslateModule],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MaterialModule,
    OnlineStatusModule,
    MatSidenavModule,
    ToastrModule.forRoot({
      preventDuplicates: true,
      countDuplicates: true,
      resetTimeoutOnDuplicate: true,
      maxOpened: 3,
    }),
    AuthModule,
    FormsModule,
    NgSelectModule,
    MatIconModule,
    SharedModule,
    MarkdownModule,
  ],
  providers: [
    // ВАЖЛИВО: i18n провайдиться ЛИШЕ тут, у кореневому інжекторі.
    // Якщо винести це в SharedModule, кожен лінивий модуль, що його імпортує,
    // отримає власний TranslateService/TranslateStore — і зміна мови в одному
    // інстансі не дійде до інших (саме через це раніше був потрібен reload).
    provideI18n(),
    provideAnimations(),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ReqInterceptor, multi: true },
    // Увага: LOCALE_ID Angular не змінюється в рантаймі — він впливає лише на
    // date/number/currency-пайпи. Тексти перекладаються через ngx-translate
    // і оновлюються без перезавантаження (див. docs/I18N.md).
    { provide: LOCALE_ID, useFactory: readStoredLanguage },
    provideEnvironmentNgxMask(),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideLottieOptions({
      player: () => player,
    }),
    {
      provide: OVERLAY_DEFAULT_CONFIG,
      useValue: { usePopover: false },
    },
  ],
})
export class AppModule {
  constructor() {
    registerLocaleData(localeEn, 'en');
    registerLocaleData(localeUk, 'ua');
    registerLocaleData(localeRu, 'ru');
  }
}
